import * as React from "react";
import type { SVGProps } from "react";
const SvgReduceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="reduce_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 512a42.667 42.667 0 0 1 42.666-42.667h597.334a42.667 42.667 0 1 1 0 85.334H213.333A42.667 42.667 0 0 1 170.667 512z"
    />
  </svg>
);
export default SvgReduceIcon;
